export function Spinner({ className = "" }: { className?: string }) {
  return (
    <div className={`flex items-center justify-center py-10 ${className}`}>
      <div className="w-6 h-6 border-2 border-surface-border border-t-accent rounded-full animate-spin" />
    </div>
  );
}

export function EmptyState({ message }: { message: string }) {
  return <div className="text-center py-10 text-sm text-gray-500">{message}</div>;
}
